export enum InvoiceFormat {
    Summary = 1,
    Detailed = 2
}
